module.exports = __webpack_public_path__ + "img/beer_id-114.b0c492d8.png";